/** Images for manage-assignment UI only — not shared with marketing/homepage. */

export type ManageAssignmentParty = 'athlete' | 'coach' | 'guardian';

export interface ManageAssignmentRoleVisual {
    party: ManageAssignmentParty;
    image: string;
}

export const MANAGE_ASSIGNMENT_ROLE_VISUALS: Record<
    ManageAssignmentParty,
    ManageAssignmentRoleVisual
> = {
    athlete: { party: 'athlete', image: '/images/athlete.png' },
    coach: { party: 'coach', image: '/images/coach.png' },
    guardian: { party: 'guardian', image: '/images/guardian.png' },
};
